exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DetailsBlock_details-block_3CDT {\n  margin-bottom: 20px;\n\n  display: -webkit-box;\n\n  display: -webkit-flex;\n\n  display: -ms-flexbox;\n\n  display: flex;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n\n  .DetailsBlock_details-block__title_1YOv {\n    margin: 0 0 16px 0;\n  }\n\n  .DetailsBlock_details-block__period_1Vdb {\n    margin: 0 0 16px 0;\n  }\n", ""]);

// exports
exports.locals = {
	"details-block": "DetailsBlock_details-block_3CDT",
	"details-block__title": "DetailsBlock_details-block__title_1YOv",
	"details-block__period": "DetailsBlock_details-block__period_1Vdb"
};